import useToastMessage from "components/ToastMessage/utils/hooks/useToastMessage";
import { useState } from "react";
import { requestSaveEventAttendanceStudent } from "services/events/attendance";

const useSaveAttendance = ({
	dialogSaveAttendance,
	setCanShowDialogLeavingPage,
	studentReservations,
	loadingRequest,
}) => {
	const [errorSaveAttendance, setErrorSaveAttendance] = useState(false);
	const toastErrorSaveAttendance = useToastMessage();

	async function doRequestSaveAttendance() {
		loadingRequest.show("Guardando asistencia...");
		try {
			const response = await requestSaveEventAttendanceStudent(studentReservations.value);
			if (!response.success) {
				// Mostrar el mensaje de error del backend
				toastErrorSaveAttendance.show(response.message || "Ocurrió un error al guardar la asistencia.");
				setTimeout(() => {
					toastErrorSaveAttendance.hide();
				}, 2400);
				return response; // Devuelve la respuesta para que saveAttendance pueda manejarla
			}
			return response; // Devuelve la respuesta exitosa
		} catch (error) {
			// Manejo de errores inesperados
			toastErrorSaveAttendance.show("Error inesperado al guardar la asistencia.");
			setTimeout(() => {
				toastErrorSaveAttendance.hide();
			}, 2400);
			return null; // Devuelve null en caso de error inesperado
		} finally {
			loadingRequest.hide();
		}
	}

	function noStudentReservationsAction() {
		setErrorSaveAttendance(true);
		// Mostrando mensaje de error al agregar porque el estudiante ya existe
		toastErrorSaveAttendance.show(
			"Tienes que agregar asistencia para pasar al siguiente paso."
		);
		setTimeout(() => {
			toastErrorSaveAttendance.hide();
		}, 2400);
	}
	const saveAttendance = async () => {
		const noStudentReservations =
			studentReservations.noStudentsHaveAttendance();
		if (noStudentReservations) {
			noStudentReservationsAction();
			return;
		}
		const response = await doRequestSaveAttendance();
		if (response?.success) {
			// Deshabilitando aviso de salida sin guardar
			setCanShowDialogLeavingPage(false);
			dialogSaveAttendance.set(true);
		}
	};
	return {
		saveAttendance,
		toastErrorSaveAttendance,
		errorSaveAttendance: {
			value: errorSaveAttendance,
			set: setErrorSaveAttendance,
		},
	};
};

export default useSaveAttendance;
